import { useState } from 'react'
import { Icon } from '@carrent/ui'

/**
 * Полка отключённых гаджетов.
 *
 * Отключение — не удаление: размер, позиция и настройки на месте,
 * гаджет просто не рисуется и не запрашивает данные. Полка нужна,
 * чтобы выключенное не исчезало бесследно и возвращалось одним кликом.
 */
export function DisabledTray({ layout, catalog, canEdit, onEnable }) {
  const [open, setOpen] = useState(false)
  const disabled = layout.filter((w) => !w.enabled)

  if (!disabled.length) return null

  return (
    <section className="tray">
      <button
        type="button"
        className="tray__toggle"
        aria-expanded={open}
        onClick={() => setOpen((v) => !v)}
      >
        <Icon name={open ? 'chevronLeft' : 'chevronRight'} size={16} />
        Отключено ({disabled.length})
      </button>

      {open && (
        <ul className="tray__list">
          {disabled.map((w) => (
            <li key={w.id}>
              <button
                type="button"
                className="tray__chip"
                disabled={!canEdit}
                onClick={() => onEnable(w.id)}
              >
                <Icon name="plus" size={14} />
                {catalog[w.type]?.title || w.type}
              </button>
            </li>
          ))}
        </ul>
      )}
    </section>
  )
}
